import * as React from 'react'
import { IAssistanceCategoryObject } from '../../types/index'

export interface IAssistanceCategoryItemProps {
  category: IAssistanceCategoryObject
  onRemove: (category: IAssistanceCategoryObject) => void
}

const AssistanceCategoryListItem = ({ category, onRemove }: IAssistanceCategoryItemProps) => {
  const toRemove = () => {
    onRemove(category)
  }

  return (
    <div className='mt1'>
      <div className='flex justify-between pl3'>
        <span className='AssistanceCategoryListItemName'>{category.name}</span>
        <button type='button' onClick={toRemove} className='btn bg-white rounded font-light-grey mr2'>
          x
        </button>
      </div>
    </div>
  )
}

export default AssistanceCategoryListItem



// WEBPACK FOOTER //
// ./src/components/assistance/AssistanceEditCategoryModalListItem.tsx